export default "__VITE_ASSET__DP0nxf3L__"